<div class="divisor20"></div>
<div>
    <div class="divisor8"></div>
    <div class="row">
        <div class="col-lg-12 col-lg-12 col-sm-12 col-12">
            <!-- Hijos -->
            <div class="row">
                <div class="col-12">
                    <span class="labelDescripcionGris">Estudios del profesor</span>
                </div>
            </div>

            <div class="divisor20" *ngIf="!disabled"></div>
            <div class="row" *ngIf="!disabled">
                <div class="col-12">
                    <div class="panelBotonesFiltro mixto">
                        <button  class="btn boton botonXS" (click)="Modal()">
                            <span class="fa fa-plus"></span>
                            <span> {{'Agregar'}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="divisor16"></div>

            <!-- datos -->
            <dx-data-grid 
                id="tabla"
                [columnAutoWidth]="true"
                [dataSource]="dataTable"
                [showColumnHeaders]="true"
                >

                <dxi-column *ngIf="!disabled"
                    [allowExporting]="false"
                    caption="Acciones"
                    cellTemplate="cellAcciones"
                    alignment="center">

                </dxi-column>
                <dxi-column
                    dataField="escolaridad"
                    caption="Nivel de estudio">
                </dxi-column>
                <dxi-column
                    dataField="titulo"
                    caption="Título">
                </dxi-column>
                <dxi-column
                    dataField="institucioneducativa"
                    caption="Institución educativa">
                </dxi-column>
                <dxi-column
                    dataField="estatus"
                    caption="Estatus">
                </dxi-column>
                <dxi-column
                    dataField="cedulaprofesional"
                    caption="Cédula profesional">
                </dxi-column>

                <!-- Acciones -->
                <div *dxTemplate="let cell of 'cellAcciones'">  
                    <a matTooltip="Editar" class="tablaBoton edit" (click)="Editar(cell.data)">
                        <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                    </a>
                    <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)">
                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                    </a>
                </div>

            </dx-data-grid>
        </div>
    </div>
</div>

<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">

        <div class="contenido">
            <!-- Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{(entidad.colaboradorestudioid == 0 ? 'Agregar' : 'Editar')}}
                </div>
            </div>
            <div class="modalContenido">
                <!-- datos -->
                <div>
                    <div class="divisor8"></div>
                    <div>
                        <!-- Datos generales -->
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <dropdownCustom [titulo]="'Nivel de estudios'" 
                                    [(ngModel)]="entidad.escolaridadid" 
                                    [opciones]="SelEscolaridad"
                                    [valorName]="'escolaridadid'"
                                    [displayValor]="'descripcion'"
                                    [errorActivo]="errorActivo"
                                    ></dropdownCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <inputCustom [titulo]="'Título'" [(ngModel)]="entidad.titulo" [errorActivo]="errorActivo"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <inputCustom [titulo]="'Institución educativa'" [(ngModel)]="entidad.institucioneducativa" [errorActivo]="errorActivo"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <inputCustom [titulo]="'Cédula profesional'" [(ngModel)]="entidad.cedulaprofesional" [verError]="false"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <dropdownCustom [titulo]="'Estatus'" 
                                    [(ngModel)]="entidad.estatusestudioid" 
                                    [opciones]="SelEstatusEstudio"
                                    [valorName]="'estatusestudioid'"
                                    [displayValor]="'nombre'"
                                    [errorActivo]="errorActivo"
                                    [buscar]="false"
                                    ></dropdownCustom>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <!-- editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            {{'Guardar' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>